export type Nullish = null | undefined

export function isNotNullish(value: any): boolean {
  return value !== undefined && value !== null
}
